export default "__VITE_ASSET__D$bYk$Rb__"